import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import { Client } from "@stomp/stompjs";
import Clients from "../Clients/Clients";
import Directory from "../Clients/Directory";
import Home from "./Home/Home";
import LogModal from "../Logs/LogModal";
import Login from "./Login";
import Map2 from "../Logs/Map2";
import React from "react";
import Remote from "../Remote/Remote";
import Settings from "../Settings/Settings";
import SideMenu from "./SideMenu";
import Stats from "../Stats";
import SuiviLogs from "../Logs/SuiviLogs";
import Cartographie from "../Supervision/Cartographie";
import UsageVues from "../Supervision/UsageVues";
import axios from "../../utils/axios";
import { isGuacamoleEnabled } from "../../utils/guacamole";
import { notification } from "antd";
import { useSelector } from "react-redux";

function Main(props) {
  const keycloak = useSelector((state) => state.keycloak);
  const [stompClient, setStompClient] = useState();
  const [runningClient, setRunningClient] = useState();
  const [token, setToken] = useState("");

  async function getToken() {
    // Le token admin Guacamole est obtenu COTE SERVEUR (voir GuacamoleController) :
    // aucun identifiant Guacamole n'est present dans le bundle front.
    const res = await axios.get("/api/guacamole/token");
    if (res.data?.authToken) {
      setToken(res.data.authToken);
    }
  }

  const initStomp = async () => {
    // Secrets hors du bundle : configures via REACT_APP_MQ_* (build/dev env).
    // Sans configuration, on ne tente pas la connexion (pas de secret en dur).
    const mqUrl = process.env.REACT_APP_MQ_URL;
    const mqLogin = process.env.REACT_APP_MQ_LOGIN;
    const mqPasscode = process.env.REACT_APP_MQ_PASSCODE;
    if (!mqUrl || !mqLogin || !mqPasscode) {
      return;
    }
    if (!stompClient) {
      let runningClient;
      const client = new Client({
        brokerURL: mqUrl,
        connectHeaders: {
          login: mqLogin,
          passcode: mqPasscode,
        },
        // debug: function (str) {
        //   console.log(str);
        // },
        onConnect: function (frame) {
          // The return object has a method called `unsubscribe`
          runningClient = client.subscribe(
            "/exchange/reply",
            function (message) {
              const payload = JSON.parse(message.body);
              let type = payload.status === 0 ? "success" : "error";
              notification[type]({
                message: "Message",
                description: payload.message,
              });
            }
          );
        },
      });
      setStompClient(client);
      setRunningClient(runningClient);
    }
  };

  useEffect(() => {
    if (keycloak.authenticated) {
      initStomp();
      if (isGuacamoleEnabled()) {
        getToken();
      }
    }
    // eslint-disable-next-line
  }, [keycloak.authenticated]);

  const location = useLocation();

  useEffect(() => {
    if (keycloak.authenticated && stompClient) {
      stompClient.activate();
    }
    return () => {
      if (runningClient) {
        runningClient.unsubscribe();
      }
    };
  }, [keycloak.authenticated, runningClient, stompClient]);

  if (!keycloak.authenticated && location.pathname !== "/login") {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { referrer: location.pathname + location.search },
        }}
      />
    );
  }
  return (
    <>
      {keycloak.authenticated && <SideMenu />}
      <LogModal />
      <div className="main-content">
        <Switch>
          <Route exact path="/login" component={Login} />
          {keycloak.authenticated && (
            <>
              <Route exact path="/home" component={Home} />
              <Route path="/map" component={Map2} />
              <Route exact path="/logs/suivi">
                <Redirect to="/logs/monitoring" />
              </Route>
              <Route exact path="/logs/monitoring" component={SuiviLogs} />
              <Route exact path="/supervision/orchestration" component={Cartographie} />
              <Route exact path="/supervision/view-usage" component={UsageVues} />
              <Route
                exact
                path="/supervision/cartography"
                render={({ location }) => (
                  <Redirect to={{ pathname: "/supervision/orchestration", search: location.search }} />
                )}
              />
              <Route exact path="/stats" component={Stats} />
              <Route exact path="/settings" component={Settings} />
              <Route exact path="/modules">
                <Redirect to="/settings?tab=referentiels&sub=modules" />
              </Route>
              <Route exact path="/repositories">
                <Redirect to="/settings?tab=referentiels&sub=repositories" />
              </Route>
              <Route exact path="/clients" component={Clients} />
              <Route exact path="/clients/directory" component={Directory} />
              <Route exact path="/remote">
                <Remote
                  resourceAccess={keycloak.keycloak.resourceAccess}
                  username={keycloak.keycloak.idTokenParsed.preferred_username}
                  token={token}
                />
              </Route>
            </>
          )}
        </Switch>
      </div>
    </>
  );
}

Main.propTypes = {};

export default Main;
